import tmhRequest from '@/config/tmhRequest'

export default {

    searchListSignInfoType: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/signinfotype/searchlistsigninfotype',
            method: 'post',
            params: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/signinfotype.js